module.exports = __webpack_public_path__ + "static/media/ranking.cca26498.jpg";